<template>
  <div>
    <SwiperHeader />
    <CampaignEven />
    <NameDonate />
  </div>
</template>

<script setup>
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperHeader from '../components/SwiperHeader.vue';
import CampaignEven from '../components/CampaignEven.vue';
import NameDonate from '../components/homePage/NameDonate.vue';
</script>

<style scoped></style>